import React from "react";
import { array } from "prop-types";

import OpinionStoryCard from "../../../molecules/OpinionStoryCard";

import "./organism2.m.css";

const Organism2 = ({ stories = [] }) => {
  if (!stories.length) return null;
  return (
    <div className="organism2" styleName="base">
      {stories.map((story) => {
        const storyData = story.story;
        const headline = storyData.headline;
        const subheadline = storyData.subheadline;
        const storySlug = storyData.url;

        return (
          <OpinionStoryCard
            story={storyData}
            headline={headline}
            subheadline={subheadline}
            key={storyData.id}
            storySlug={storySlug}
          />
        );
      })}
    </div>
  );
};

Organism2.propTypes = {
  stories: array.isRequired,
};

export default Organism2;
